import { Modal } from 'antd';
import React from 'react';

function modalMsg({ error, msg, onOk, context = 'Register' }, supportEmail) {
  const modalMsgPath = error ? `onError.${error.status}` : `onSuccess`;
  const modal = Modal[error ? 'error' : 'success'];

  const errorMsg =
    error &&
    error.status !== 400 &&
    error.status !== 409 &&
    error.status !== 404 &&
    error.status !== 500
      ? { title: error.message, content: error.detail, okText: 'Ok' }
      : {};

  const resolvedTitle = errorMsg.title || msg(`${modalMsgPath}.title`);
  const resolvedDescription =
    errorMsg.content ||
    msg(`${modalMsgPath}.description`, {
      supportEmail: (
        <a style={{ textDecoration: 'underline' }}>{supportEmail}</a>
      ),
    });
  const resolvedOkText = errorMsg.okText || msg(`${modalMsgPath}.btn.label`);

  const toPlainText = val =>
    typeof val === 'string' ? val : (error && error.detail) || '';

  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    const basePayload = {
      ui_component: 'AuthFormModal',
      form_name: context,
    };
    if (error) {
      window.dataLayer.push({
        event: `${context.toLowerCase()}_error`,
        error_status: String(error.status),
        error_title:
          typeof resolvedTitle === 'string' ? resolvedTitle : 'Error',
        error_description: toPlainText(resolvedDescription),
        ...basePayload,
      });
    } else {
      window.dataLayer.push({
        event: `${context.toLowerCase()}_success`,
        ...basePayload,
      });
    }
  }

  const email = <a style={{ textDecoration: 'underline' }}>{supportEmail}</a>;
  modal({
    title: resolvedTitle,
    content:
      errorMsg.content ||
      msg(`${modalMsgPath}.description`, { supportEmail: email }),
    okText: resolvedOkText,
    okButtonProps: { id: `${modalMsgPath}.btn.label` },
    onOk,
  });
}

export default modalMsg;
